/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIContactGroupCreationRequest
 */
export interface APIContactGroupCreationRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIContactGroupCreationRequest
     */
    contacts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIContactGroupCreationRequest
     */
    name: string;
}

/**
 * Check if a given object implements the APIContactGroupCreationRequest interface.
 */
export function instanceOfAPIContactGroupCreationRequest(value: object): value is APIContactGroupCreationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIContactGroupCreationRequestFromJSON(json: any): APIContactGroupCreationRequest {
    return APIContactGroupCreationRequestFromJSONTyped(json, false);
}

export function APIContactGroupCreationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactGroupCreationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contacts': json['contacts'] == null ? undefined : json['contacts'],
        'name': json['name'],
    };
}

export function APIContactGroupCreationRequestToJSON(value?: APIContactGroupCreationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'contacts': value['contacts'],
        'name': value['name'],
    };
}

